/** True when the URL contains Supabase OAuth callback params (hash or PKCE query). */
export function hasOAuthUrlParams() {
  const hash = window.location.hash.replace(/^#/, '')
  if (hash) {
    const hashParams = new URLSearchParams(hash)
    if (
      hashParams.has('access_token') ||
      hashParams.has('refresh_token') ||
      hashParams.has('error') ||
      hashParams.has('error_description')
    ) {
      return true
    }
  }

  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.has('code')
}

/** Routes where Supabase may land after OAuth before we send the user to the app. */
export function isOAuthReturnPath(pathname) {
  return (
    pathname === '/' ||
    pathname === '/login' ||
    pathname === '/signup' ||
    // Legacy bookmarks / old Supabase Site URL redirects
    pathname === '/app/login' ||
    pathname === '/app/signup'
  )
}

/** Remove OAuth tokens/errors from the address bar after Supabase parses the session. */
export function clearOAuthUrlParams() {
  const url = new URL(window.location.href)
  url.hash = ''
  url.searchParams.delete('code')
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}`)
}

export function getOAuthErrorFromUrl() {
  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
  return hashParams.get('error_description') || hashParams.get('error') || null
}
